import { Button, Card, Form, Input, message, Modal, Select, Breadcrumb } from "antd";
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { ExclamationCircleOutlined, ArrowLeftOutlined, SaveOutlined, DeleteOutlined, HomeOutlined, InfoCircleOutlined, AppstoreOutlined } from "@ant-design/icons";
import slugify from "slugify";

export default function CourseForm({
    id = "",
    initialValues = {},
    onSubmit = () => {},
}) {
    const navigate = useNavigate();
    const [form] = Form.useForm();
    const [topics, setTopics] = useState([]);
    const [pagination] = useState({ page: 1, pageSize: 100 });

    const fetchTopics = async () => {
        try {
            const result = await axios.get(
                `${process.env.REACT_APP_API_URL}/topic/getAll`, { params: pagination }
            );
            setTopics(result?.data?.data);
        } catch (e) {
            message.error("Không thể tải danh sách topic");
        }
    };

    const deleteCourse = () => {
        axios
            .delete(`${process.env.REACT_APP_API_URL}/course/delete/${id}`)
            .then(() => {
                message.success("Xoá khóa học thành công");
                navigate("/admin/course");
            });
    };

    const handleCourseSlugChange = (e) => {
        form.setFieldValue("slug", slugify(e.target.value, { lower: true }));
    };

    useEffect(() => {
        fetchTopics();
        if (Object.keys(initialValues)?.length > 0) {
            form.resetFields();
        }
    }, [form, initialValues]);

    const confirmDelete = () => {
        Modal.confirm({
            icon: <ExclamationCircleOutlined />,
            content: "Bạn có chắc chắn xoá khóa học này?",
            okText: "Xác nhận",
            cancelText: "Huỷ",
            onOk: () => deleteCourse(),
        });
    };

    return (
        <div>
            {/* Header */}
            <div className="mb-6">
                <Breadcrumb items={[
                    { title: <Link to="/admin"><HomeOutlined /> Dashboard</Link> },
                    { title: <Link to="/admin/course">Course</Link> },
                    { title: id ? "Chỉnh sửa" : "Tạo mới" },
                ]} />
                <div className="flex items-center justify-between mt-4">
                    <div className="flex items-center gap-3">
                        <Button icon={<ArrowLeftOutlined />} onClick={() => navigate("/admin/course")} />
                        <h1 className="text-2xl font-bold text-gray-800 m-0">
                            {id ? "Chỉnh sửa Course" : "Tạo Course mới"}
                        </h1>
                    </div>
                    <div className="flex items-center gap-2">
                        {id && (
                            <Button danger icon={<DeleteOutlined />} size="large" onClick={confirmDelete}>
                                Xoá
                            </Button>
                        )}
                        <Button type="primary" size="large" icon={<SaveOutlined />}
                            className="bg-blue-500 min-w-[140px] font-semibold shadow-md"
                            onClick={() => form.submit()}>
                            {id ? "Cập nhật Course" : "Tạo Course"}
                        </Button>
                    </div>
                </div>
            </div>

            <Form
                layout="vertical"
                colon={false}
                form={form}
                initialValues={initialValues}
                onFinishFailed={(e) => console.log(e)}
                onFinish={onSubmit}
            >
                {/* Basic Info */}
                <Card
                    title={<span className="text-base"><InfoCircleOutlined className="mr-2 text-blue-500" />Thông tin cơ bản</span>}
                    className="mb-5 shadow-sm rounded-xl border-0"
                    headStyle={{ borderBottom: '2px solid #f0f0f0' }}
                >
                    <Form.Item
                        label="Tiêu đề"
                        name="title"
                        rules={[{ required: true, message: "Vui lòng nhập tiêu đề!" }]}
                    >
                        <Input size="large" placeholder="Nhập tiêu đề khóa học" onChange={handleCourseSlugChange} />
                    </Form.Item>
                    <Form.Item
                        label="Slug (URL)"
                        name="slug"
                        rules={[{ required: true, message: "Vui lòng nhập slug!" }]}
                        extra="Tự động tạo từ tiêu đề, có thể chỉnh sửa"
                    >
                        <Input size="large" placeholder="slug-cua-course" onBlur={handleCourseSlugChange} />
                    </Form.Item>
                    <Form.Item
                        label="Mô tả ngắn"
                        name="description"
                        extra="Hiển thị dưới tiêu đề trên danh sách khóa học"
                    >
                        <Input.TextArea rows={3} placeholder="Nhập mô tả ngắn cho khóa học" showCount maxLength={200} />
                    </Form.Item>
                </Card>

                {/* Classification */}
                <Card
                    title={<span className="text-base"><AppstoreOutlined className="mr-2 text-purple-500" />Phân loại</span>}
                    className="mb-5 shadow-sm rounded-xl border-0"
                    headStyle={{ borderBottom: '2px solid #f0f0f0' }}
                >
                    <Form.Item
                        label="Chọn Topic"
                        name="topic_id"
                        rules={[{ required: true, message: "Vui lòng chọn topic!" }]}
                    >
                        <Select
                            showSearch
                            size="large"
                            placeholder="Chọn topic cho khóa học"
                            optionFilterProp="children"
                            options={topics?.map((value) => ({
                                value: value.id,
                                label: value.title,
                            }))}
                        />
                    </Form.Item>
                </Card>
            </Form>
        </div>
    );
}
